<template>
  <el-drawer
    :title="title"
    :append-to-body="appendToBoddy"
    :visible.sync="drawer"
    :with-header="true"
    size="70%"
    :before-close="handleOpenDrawer"
  >
    <el-container>
      <el-main>
        <el-row>
          <el-col>
            <el-form
              :model="dataHeader"
              label-position="left"
              size="mini"
              label-width="120px"
            >
              <el-collapse accordion v-model="activeColapseName">
                <el-collapse-item name="1">
                  <template slot="title" class="name_clicked">
                    <h2 title="Dar click para colapsar">
                      {{ dataHeader.Nombre }}
                    </h2>
                    <i class="header-icon el-icon-information"></i>
                  </template>
                  <div class="tags">
                    <el-tooltip
                      effect="dark"
                      content="Día de Facturación"
                      placement="top-start"
                      :disabled="!dataHeader.Dia_Facturacion"
                    >
                      <el-tag
                        type="success"
                        v-if="dataHeader.Dia_Facturacion"
                        >{{ dataHeader.Dia_Facturacion }}</el-tag
                      >
                    </el-tooltip>

                    <el-tooltip
                      effect="dark"
                      content="Estatus"
                      placement="top-start"
                      :disabled="!dataHeader.Contract_Conditions"
                    >
                      <el-tag
                        type="success"
                        v-if="dataHeader.Contract_Conditions"
                        >{{ dataHeader.Contract_Conditions }}</el-tag
                      >
                    </el-tooltip>

                    <el-tooltip
                      effect="dark"
                      content="Código de Cliente"
                      placement="top-start"
                      :disabled="!dataHeader.Cliente_No"
                    >
                      <el-tag type="success" v-if="dataHeader.Cliente_No">{{
                        dataHeader.Cliente_No
                      }}</el-tag>
                    </el-tooltip>
                  </div>
                  <hr />

                  <el-row :gutter="20" class="mt-20" type="flex column">
                    <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
                      <el-form-item label="No. Contrato">
                        <el-input
                          v-if="dataHeader.No_Contrato"
                          v-model="dataHeader.No_Contrato"
                          :disabled="true"
                        ></el-input>
                        <el-input
                          v-else=""
                          v-model="dataHeader.NoContrato"
                          :disabled="true"
                        ></el-input>
                      </el-form-item>
                      <el-form-item label="Tipo Proceso">
                        <el-input
                          v-if="dataHeader.Tipo_Proceso"
                          v-model="dataHeader.Tipo_Proceso"
                          :disabled="true"
                        ></el-input>
                        <el-input
                          v-else=""
                          v-model="dataHeader.TipoProceso"
                          :disabled="true"
                        ></el-input>
                      </el-form-item>
                      <el-form-item label="Fecha Inicio">
                        <el-input
                          v-if="dataHeader.Fecha_Inicio"
                          v-model="dataHeader.Fecha_Inicio"
                          :disabled="true"
                        ></el-input>
                        <el-input
                          v-else=""
                          v-model="dataHeader.FechaInicio"
                          :disabled="true"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="20" :xs="20" :sm="24" :md="24" :lg="8">
                      <el-form-item label="Fecha Final">
                        <el-input
                          v-if="dataHeader.Fecha_Final"
                          v-model="dataHeader.Fecha_Final"
                          :disabled="true"
                        ></el-input>
                        <el-input
                          v-else=""
                          v-model="dataHeader.FechaVence"
                          :disabled="true"
                        ></el-input>
                      </el-form-item>
                      <el-form-item label="Ultima Factura">
                        <el-input
                          v-if="dataHeader.Ult_Fecha_Fact"
                          v-model="dataHeader.Ult_Fecha_Fact"
                          :disabled="true"
                        ></el-input>
                        <el-input
                          v-else=""
                          v-model="dataHeader.UltFechaFacturacion"
                          :disabled="true"
                        ></el-input>
                      </el-form-item>

                      <el-form-item label="Proxima Factura">
                        <el-input
                          v-if="dataHeader.Próx_Fecha_Facturación"
                          v-model="dataHeader.Próx_Fecha_Facturación"
                          :disabled="true"
                        ></el-input>
                        <el-input
                          v-else=""
                          v-model="dataHeader.ProxFechaFacturacion"
                          :disabled="true"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-collapse-item>
              </el-collapse>
              <el-row>
                <el-col>
                  <RabbeyTable3
                    ref="table"
                    v-loading="loading"
                    :columns="columns"
                    :data="items"
                    :height="600"
                    show-summary
                  />
                </el-col>
              </el-row>
            </el-form>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </el-drawer>
</template>

<script>
import RabbeyTable3 from "@/components/RabbeyTable3.vue";
import { formatMonto, formatDate } from "@/utils";

export default {
  name: "TableContractsDetails",
  props: {
    appendToBoddy: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  components: { RabbeyTable3 },
  data() {
    return {
      activeColapseName: ["1"],
      personType: "",
      Option: "",
      contractNo: "",
      clientName: "",
      month: 0,
      title: "Datos de los clientes sin Visitar",
      drawer: false,
      cantidad: 0,
      PersonName: "",
      loading: false,
      items: [],
      contracsCancells: [],
      dataHeader: [],
      columns: [
        {
          prop: "Descripcion",
          label: "Descripción",
          minWidth: 500,
          fixed: true
        },
        {
          prop: "Cantidad",
          label: "Cantidad",
          minWidth: 80,
          fixed: true
        },
        {
          prop: "Precio_Unitario",
          label: "Precio por unidad",
          minWidth: 150,
          fixed: true
        },
        {
          prop: "Fecha_de_Venta",
          label: "Fecha de venta",
          minWidth: 300,
          fixed: true
        },
        {
          prop: "Fecha_Inicio",
          label: "Fecha de Inicio",
          minWidth: 300,
          fixed: true
        },
        {
          prop: "Fecha_Final",
          label: "Fecha fianal",
          minWidth: 300,
          fixed: true
        }
      ]
    };
  },
  methods: {
    formatMonto,
    formatDate,
    clearData() {
      this.contracsCancells = [];
      this.cantidad = 0;
    },
    show(props) {
      //console.log("show props: ", props);
      this.clientName = props.row.Nombre;
      this.contractNo = props.row.No_Contrato || props.row.NoContrato;
      this.dataHeader = props.row;

      let params = {
        contractNo: this.contractNo,
        companyCode: this.currentCompany
      };
      let title = "Detalle de las líneas de contratos";
      let url = "/api/contracts/GetContratsDetails";
      this.title = title;

      this.drawer = true;
      this.loading = true;

      this.$http
        .get(url, { params: params })
        .then((resp) => {
          if (resp.data["Items"] !== undefined) {
            const { Items } = resp.data;
            this.items = Items;
            this.cantidad = Items.length;
          } else {
            this.items = resp.data;
            this.data = resp.data;
            resp.data.forEach((c) => {
              this.cantidad = this.cantidad + c.Cantidad;
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleOpenDrawer(done) {
      this.clearData();
      done();
    }
  }
};
</script>

<style></style>
